// CampoNome.tsx — il nome con cui l'avversario ti vede. v038: il nome si scrive UNA volta (registrazione o prima
// sfida); poi qui c'è solo «Giochi come X». Con l'account si cambia dal profilo; senza account (niente profilo) con
// «Cambia» si riapre il campo.
import { useEffect, useId, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { NOME_MAX } from "../../../condiviso/protocollo.ts";
import { useAccount } from "../servizi/account.ts";
import { vai } from "../servizi/percorso.ts";
import { leggiPreferenza } from "../servizi/preferenze.ts";
import { PERCORSO_PROFILO, PREFERENZE } from "../costanti.ts";

/**
 * v039: il nome con cui si gioca: quello dell'account (anche su un telefono nuovo, dove l'ultimo nome usato non c'è),
 * altrimenti l'ultimo usato su questo telefono. Se l'account arriva dopo (si sta ancora caricando), si prende il suo
 * nome finché non si è scritto niente.
 */
export function useNomeGiocatore(): [string, (v: string) => void] {
  const account = useAccount();
  const [nome, setNome] = useState(() => (account.tipo === "registrato" ? account.io.nome : leggiPreferenza(PREFERENZE.nome)) ?? "");
  const toccato = useRef(false);
  const nomeAccount = account.tipo === "registrato" ? account.io.nome : null;
  useEffect(() => {
    if (nomeAccount && !toccato.current) setNome(nomeAccount);
  }, [nomeAccount]);
  return [
    nome,
    (v: string) => {
      toccato.current = true;
      setNome(v);
    },
  ];
}

/** `sempre`: il campo si mostra comunque (registrazione: è il momento in cui il nome si sceglie). */
export function CampoNome({ valore, onCambia, sempre = false }: { valore: string; onCambia: (v: string) => void; sempre?: boolean }) {
  const { t } = useTranslation();
  const id = useId();
  const account = useAccount();
  const registrato = account.tipo === "registrato";
  // il nome era già noto quando si è aperto il modulo (account o ultima volta)
  const [noto] = useState(() => valore.trim() !== "");
  const [apri, setApri] = useState(false);
  if (!sempre && (registrato || noto) && valore.trim() && !apri)
    return (
      <p className="campo-nome-noto">
        <span>{t("gioco.giochi_come", { nome: valore.trim() })}</span>{" "}
        <button type="button" className="pulsante-link" onClick={() => (registrato ? vai(PERCORSO_PROFILO) : setApri(true))}>
          {t("gioco.cambia_nome")}
        </button>
      </p>
    );
  return (
    <label className="campo-nome" htmlFor={id}>
      <span className="etichetta">{t("gioco.tuo_nome")}</span>
      <input
        id={id}
        className="campo"
        value={valore}
        maxLength={NOME_MAX}
        autoComplete="nickname"
        enterKeyHint="go"
        placeholder={t("gioco.nome_esempio")}
        onChange={(e) => onCambia(e.target.value)}
        required
      />
      <span className="nota">{t("gioco.nome_suggerimento")}</span>
    </label>
  );
}
